import React from "react";
import styles from "../../styles/HomePage.module.css"; // ✅ Required import

const categories = [
  {
    title: "Hatchback",
    img: "https://images.unsplash.com/photo-1605559424843-9e4c228bf1c2?auto=format&fit=crop&w=1524&q=80",
  },
  {
    title: "SUV",
    img: "https://images.unsplash.com/photo-1555215695-3004980ad54e?auto=format&fit=crop&w=1470&q=80",
  },
  {
    title: "Sedan",
    img: "https://images.unsplash.com/photo-1541899481282-d53bffe3c35d?auto=format&fit=crop&w=1470&q=80",
  },
  {
    title: "Luxury",
    img: "https://images.unsplash.com/photo-1541899481282-d53bffe3c35d?auto=format&fit=crop&w=1470&q=80",
  },
];

const CategorySection = () => {
  return (
    <section className={styles.categories}>
      <div className={styles.container}>
        <h2 className={styles.sectionTitle}>Shop By Category</h2>
        <div className={styles.categoryGrid}>
          {categories.map((cat, idx) => (
            <div key={idx} className={styles.categoryCard}>
              <div className={styles.categoryImg}>
                <img src={cat.img} alt={cat.title} />
              </div>
              <div className={styles.categoryInfo}>
                <h3>{cat.title}</h3>
                <a href="#" className={styles.btn}>
                  View Cars
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategorySection;
